import { List, ListOrdered } from "lucide-react";
import { useState } from "react";
import type { CanvasListType } from "./canvasListCommands";
import { canvasToolbarIconClassName } from "./canvasToolbarIcon";
import {
  CanvasToolbarButton,
  CanvasToolbarGroup,
  CanvasToolbarSubmenu,
} from "./index";

function ListDashIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.75"
      strokeLinecap="round"
      aria-hidden
    >
      <line x1="9" x2="20" y1="6" y2="6" />
      <line x1="9" x2="20" y1="12" y2="12" />
      <line x1="9" x2="20" y1="18" y2="18" />
      <line x1="3" x2="6" y1="6" y2="6" />
      <line x1="3" x2="6" y1="12" y2="12" />
      <line x1="3" x2="6" y1="18" y2="18" />
    </svg>
  );
}

const LIST_ITEMS: { type: CanvasListType; label: string }[] = [
  { type: "bullet", label: "Bullets" },
  { type: "dash", label: "Dashes" },
  { type: "numbered", label: "Numbered" },
];

interface CanvasToolbarListMenuProps {
  onListTypeSelect: (type: CanvasListType) => void;
  onOpenChange?: (open: boolean) => void;
}

/** Chained list submenu — Bullets / Dashes / Numbered (DS Format ▸ List). */
export function CanvasToolbarListMenu({
  onListTypeSelect,
  onOpenChange,
}: CanvasToolbarListMenuProps) {
  const [open, setOpen] = useState(false);

  const handleOpenChange = (next: boolean) => {
    setOpen(next);
    onOpenChange?.(next);
  };

  return (
    <CanvasToolbarSubmenu
      open={open}
      onOpenChange={handleOpenChange}
      side="top"
      sideOffset={4}
      trigger={
        <CanvasToolbarButton
          label="List"
          dropdown
          active={open}
          aria-expanded={open}
          onClick={(e) => e.stopPropagation()}
        >
          <List className={canvasToolbarIconClassName} />
        </CanvasToolbarButton>
      }
    >
      <CanvasToolbarGroup>
        {LIST_ITEMS.map(({ type, label }) => (
          <CanvasToolbarButton
            key={type}
            label={label}
            onClick={(e) => {
              e.stopPropagation();
              onListTypeSelect(type);
              handleOpenChange(false);
            }}
          >
            {type === "bullet" && (
              <List className={canvasToolbarIconClassName} />
            )}
            {type === "dash" && (
              <ListDashIcon className={canvasToolbarIconClassName} />
            )}
            {type === "numbered" && (
              <ListOrdered className={canvasToolbarIconClassName} />
            )}
          </CanvasToolbarButton>
        ))}
      </CanvasToolbarGroup>
    </CanvasToolbarSubmenu>
  );
}
